import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import ProcessMainCard from "./components/processMainCard.jsx";

export function RenderProcessMain(configuration) {
  const container = document.getElementById(configuration.container);

  if (container) {
    const root = createRoot(container);
    root.render(
      <div className="process-main-widget-container">
        <div className="card">
          <ProcessMainCard configuration={configuration} />
        </div>
      </div>
    );
  }
}

document.addEventListener("DOMContentLoaded", function() {
    const widget_configs = document.querySelectorAll(".process-main-widget-config");

    for (let config of widget_configs) {
        RenderProcessMain(JSON.parse(config.innerText));
    }
});
